module.exports = __webpack_public_path__ + "img/Mr_Bricolage_logo-2.ddaf6e45.png";